module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-4.2324df67.svg";